import React from 'react';
export function ProblemSection() {
  return <section className="py-20 bg-[#f5f1e8] text-[#1a3a52]" data-id="element-134">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-135">
        <h2 className="text-3xl md:text-4xl font-serif font-bold mb-8" data-id="element-136">
          ¿Sientes esa presión constante en el pecho?
        </h2>

        <div className="space-y-6 text-lg md:text-xl leading-relaxed text-gray-700" data-id="element-137">
          <p data-id="element-138">
            Esa inquietud que no te deja estar en paz. Sé que has intentado
            muchas cosas: meditación, ejercicios de respiración, tal vez incluso
            dejarlo pasar.
          </p>

          <p data-id="element-139">
            Pero la ansiedad sigue ahí, apareciendo en los momentos más
            inoportunos, robándote la tranquilidad que mereces.
          </p>

          <div className="py-8" data-id="element-140">
            <div className="h-px w-24 bg-[#d4af37] mx-auto" data-id="element-141"></div>
          </div>

          <p className="font-medium text-[#1a3a52]" data-id="element-142">
            Déjame decirte que hay una forma diferente. <br data-id="element-143" />
            Una forma práctica, sencilla y profundamente efectiva.
          </p>
        </div>
      </div>
    </section>;
}